/* global SmartPhoneNumber, MyForm, MyWindow, Loc, Utils */

window.Campaign = {

	translations: {
		unsubscribeCampaign	: window.i18n.gettext("Désinscrire des campagnes"),
		nothing				: window.i18n.gettext("Ne rien faire"),
		unsubscribe			: window.i18n.gettext("Désinscrire"),
		unsubscribePlanned	: window.i18n.gettext("La désinscription des campagnes pour les destinataires sélectionnés a été planifiée."),
		confirmUnsubscribe	: window.i18n.gettext("Souhaitez-vous désinscrire des campagnes les destinataires selectionnés ?")
	},
	
	changeActionPreviousCampaign : function(){
		var nbSelect = $("select[field='valuePreviousCampaign']").multipleSelect("getSelects").length;
		if(nbSelect > 0){
			$('#msgDisplayPreviousCampaign').show();
		}else {
			$('#msgDisplayPreviousCampaign').hide();
		}
	},

	create : function(){
	
		var formID = "campaignForm";
		var data = {
			action		: "campaignCreateForm", 
		};
		
		var options = {
			title :  Loc.g('Nouvelle campagne'),
			buttons:
					[
                        {
                            text: Loc.g("Annuler"),
                            click: function() {
                                $(this).dialog("close");
                            }
                        },
                        {
							text: Loc.g("Créer la campagne et continuer"),
							click: function() {
								$("#" + formID).submit();
							}
						}
					],
			width: 1200,
			height: 670,
			callback: function() {
				$('input[name=campaign_type]').bind('change', function(){
					
					
					$('.campaignsegment .token-input-list').remove();
					$('#campaign_segments_campaign').tokenInput('clear');
					
					var type = $(this).val();
					var buttonset = [];
					$('.campaign-subform:not(.campaign-'+type+')').slideUp(200);
					$('.campaign-'+type).slideDown(200);
					
					
					if($(this).val() == 'sms'){
						buttonset = [
						{
							"class" : "btn btn-default",
							text: Loc.g("Annuler"), 
							click: function() {
								$(this).dialog("close");
							}
						},
						{
							"class" : "btn btn-primary",
							text: Loc.g("Créer la campagne"), 
							click: function() {
								$("#" + formID).submit();
							}
						},
					];
					
					$('#campaign_campaignSegmentParams').find('option[value*="click"]').attr('disabled', true);
					$('#campaign_campaignSegmentParams').multipleSelect('refresh');
					
					$('#campaign_segments_campaign').attr('e_autocampaign', 'sms');
					TokenInput.autoCampaign($('#campaign_segments_campaign'), 'sms', 10, 'sent');
					
					}else{
						buttonset = [
							{
								"class" : "btn btn-default",
								text: Loc.g("Annuler"), 
								click: function() {
									$(this).dialog("close");
								}
							},
							{
								"class" : "btn btn-primary",
								text: Loc.g("Créer la campagne et continuer"), 
								click: function() {
									$("#" + formID).submit();
								}
							},
						];
						$('#campaign_segments_campaign').attr('e_autocampaign', 'email');
						TokenInput.autoCampaign($('#campaign_segments_campaign'), 'email', 10, 'sent');
						
						$('#campaign_campaignSegmentParams').find('option[value*="click"]').removeAttr('disabled');
						$('#campaign_campaignSegmentParams').multipleSelect('refresh');
					}
					
					MyWindow.addOption('buttons', buttonset);
				});
				
				$(':input[name=sms_message]').bind('keyup', function(){
					var textLength = $(this).val().length;
					$('#messageCounter .counterChars').html(textLength);
					
					if(textLength >= $(this).attr('maxlength')){
						$('#messageCounter .counterChars').addClass('msg_warning');
					}else{
						$('#messageCounter .counterChars').removeClass('msg_warning');
					}
				});
				
				var options = {
					data : {action : 'recordCampaign'},
					dataType : 'json',
					success : function(data){
						var formOk = MyForm.processJson(data, formID);
					}
				};
                
                Campaign.initSavedSearch();
                Campaign.initFavorites();
				
				MyForm.prepare(formID, 'massmailing_campaign', options, true);
				MyFacture.customForm('#'+formID);
			}
		};
		
		MyWindow.load("massmailing_campaign", data, options);
	},
        
	initSavedSearch : function () {

		var multipleselectoptions = {
			placeholder: Loc.g("Sélectionnez une recherche sauvegardée"),
			width: 350,
			selectAll: false,
			position: 'bottom',
			countSelected : false,
			selectAllText: Loc.g('Tout Sélectionner'),
			allSelected: Loc.g('Tous sélectionnés'),
			onOptgroupClick: function(view){
                            Campaign.selectSavedSearch();
			},
			onClick: function(view) {
                            Campaign.selectSavedSearch();
			}
		};	
		
		var selectCFToEdit = $('#campaignForm select#campaign_segments').length > 0 ? $('#campaignForm select#campaign_segments') : null;
		selectCFToEdit && selectCFToEdit.multipleSelect(multipleselectoptions);
                
    },
    
    initFavorites: function () {

        var multipleselectoptions = {
            placeholder: Loc.g("Sélectionnez un favori"),
            width: 350,
            selectAll: false,
            position: 'bottom',
            countSelected: false,
            selectAllText: Loc.g('Tout Sélectionner'),
            allSelected: Loc.g('Tous sélectionnés'),
            onOptgroupClick: function (view) {
                Campaign.selectSavedSearch();
            },
            onClick: function (view) {
                Campaign.selectSavedSearch();
            }
        };

        var selectCFToEdit = $("#campaignForm select#campaign_segments_favorites").length > 0 ? $("#campaignForm select#campaign_segments_favorites") : null;
        selectCFToEdit && selectCFToEdit.multipleSelect(multipleselectoptions);

    },
	
	edit : function(campaignID, campaignType){
		var formID = "campaignForm";
		var data = {
			action		: "campaignEditForm",
			campaignID	: campaignID,
			campaignType	: campaignType,
		};
		
		var options = {
			title :  Loc.g('Edition de la campagne'),
			buttons:
					[
                        {
                            text: Loc.g("Annuler"),
                            click: function() {
                                $(this).dialog("close");
                            }
                        },
                        {
							text: Loc.g("Enregistrer"),
							click: function() {
								$("#" + formID).submit();
							}
						}
					],
			width: 1200,
			callback: function() {
				$('textarea[name=sms_message]').bind('keyup', function(){
					var textLength = $(this).val().length;
					$('#messageCounter .counterChars').html(textLength);
					
					if(textLength >= $(this).attr('maxlength')){
						$('#messageCounter .counterChars').addClass('msg_warning');
					}else{
						$('#messageCounter .counterChars').removeClass('msg_warning');
					}
				});
				
				$('textarea[name=sms_message]').trigger('keyup');
				
				var options = {
					data : {action : 'recordCampaign'},
					dataType : 'json',
					success : function(data){
						var formOk = MyForm.processJson(data, formID);
						if(formOk){
							Utils.reload();
						}
					}
				};
				
                Campaign.initSavedSearch();
                Campaign.initFavorites();

                Campaign.selectSavedSearch();
				
				MyForm.prepare(formID, 'massmailing_campaign', options, true);
				MyFacture.customForm('#'+formID);
			}	
		};
		
		MyWindow.load("massmailing_campaign", data, options);
	},
	
	initOverview : function(campaignID){

		MyTabs.initVertical('thirdOverview',{
			callback: function (item) {
				MyFacture.post('staff', {action: 'saveTab', linkedtype: 'campaign', 'linkedid': campaignID, openedTab: item.attr('id')});
			}
		});
		
		$("#emailPreview").ready(function() {
			$("#emailPreview").contents().find('a').unbind('click').bind('click', function(){
				window.open($(this).attr('href'));
				return false;
			});
		});
		
		$(document).off('focus').on('focus', '#listBAT input:last:not(.e164Number)', function(){
			var $clone = $(this).closest('li').clone();
			
			if($(this).closest('ul').find('li').length < 5){
				$clone.find('input').val('');
				$clone.appendTo($(this).closest('ul'));
			}
			
		});

		$(document).off('blur').on('blur', '#listBAT input:eq(-2):not(.e164Number)', function(){
			if($(this).val() == '' && $('ul#listBAT input:last').val() == ''){
				$('ul#listBAT li:last').remove();
			}
		});
	},
	
	loadAgendaTab : function(startTime, endTime, days, view){
		if($('#campaign-fullcalendar table').length == 0){
			setTimeout(function(){
				MyFacture.customForm();
				Agenda.initCalendar(startTime, endTime, days, view);
			} ,1000);
			
		}
	},
	
	loadRecipientsTab : function(campaignID){
		
		if($('#content_recipients .listing').html() == ''){
			var options = {
				action	: "loadListingTab",
				cid		: campaignID,
				listing	: 'recipients'
			};

			MyFacture.post('massmailing_campaign', options, function (data) {
				$('#content_recipients .listing').html(data.listing);
				Listing.init(data.prefix);
				Qtip.init();
				
				var options = {
					data : {action : 'updateListingTab', cid : campaignID, listing	: 'recipients'},
					success: function (data) {
						Listing.refresh(data.listingName, data, data[data.metadatasName]);
						Qtip.init();
						Campaign.initTips(campaignID);

					},
					dataType: "json"
				};
				MyForm.prepare(data.listingname + "FilterForm", "massmailing_campaign", options);
				MyFacture.customForm('#content_recipients .listing');
				Campaign.initTips(campaignID);
			}, 'json');
		}
	},
	
	loadReportTab : function(campaignID){
		
		if($('#emailstats_content').html() == ''){
			var options = {
				action	: "report",
				cid		: campaignID,
			};

			MyFacture.post('massmailing_campaign', options, function (data) {
				$('#emailstats_content').html(data.report);

                if (data.graph) {
                    $('#graphStats').highcharts({
                        chart : {
                            height : 250,
                            zoomType : 'x',
                            backgroundColor: "transparent",
                        },
                        title: {
                            text: '',
                            x: -20 //center
                        },
                        xAxis: {
                            categories: data.graph.axis,
                            labels: {
                                style: {
                                    fontSize: '7px'
                                },
                                step : 1
                            },
                            
                        },
                        yAxis: {
                            min		: 0,
                            title	: {enabled : false},
                        },
                        tooltip: {
                            valueSuffix: ''
                        },
                        legend: {
                            layout: 'vertical',
                            align: 'right',
                            verticalAlign: 'middle',
                            borderWidth: 0
                        },
                            credits: {
                            enabled: false
                        },
                        series: [
                            {
                                name: data.graph.opensName,
                                data: data.graph.opens,
                                color: '#61BE66',
                                marker : {enabled : false}
                            },
                            {
                                name: data.graph.clicksName,
                                data: data.graph.clicks,
                                color: '#529ECD',
                                marker : {enabled : false}
                            },
                        ]
                    });
                }
			}, 'json');
		}
	},
	
	deleteOne : function(campaignID){
		var options = {
			resizable: false,
			noclose: true,
			title: Loc.g("Suppression d'une campagne"),
			type: "warning",
			buttons: [
				{
					text: Loc.g("Non"), 
					click: function () {
						$(this).dialog("close");
					}
				},
				{
					text:Loc.g("Oui"),
					click: function () {
						var datas = {
							action		: "delete",
							campaignID	: campaignID
						};
						MyFacture.post("massmailing_campaign", datas, function (data) {
							Utils.relocate('/?_f=massmailing_campaigns');
							$(this).dialog("close");
						}, "json");
						$(this).dialog("close");
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Voulez-vous supprimer cette campagne ?"), options);

	},
	
	archiveOne : function(campaignID, action){
		var title = Loc.g("Archiver la campagne");
		var message = Loc.g("Une campagne archivée n'apparaitra pas par défaut dans vos listes de campagne. Vous pourrez tout de même la visualiser.")+'<br /><br />'+Loc.g("Voulez-vous archiver cette campagne ?");
		
		if(action == 'unarchive'){
			title	= Loc.g("Désarchiver la campagne");
			message = Loc.g("Cette campagne apparaîtra à nouveau dans vos listings par défaut.")+'<br /><br />'+Loc.g("Voulez-vous désarchiver cette campagne ?");
		}
		
		var options = {
			resizable: false,
			noclose: true,
			title: title,
			type: "warning",
			buttons: [
				{text: Loc.g("Non"), click: function () {
						$(this).dialog("close");
					}},
				{text:
					Loc.g("Oui"),
					click: function () {
						var datas = {
							action		: "archive",
							campaignID	: campaignID
						};
						MyFacture.post("massmailing_campaign", datas, function (data) {
							Utils.reload();
						}, "json");
						$(this).dialog("close");
					}
				}
				
			]
		};
		
		MyWindow.alert(message, options);

	},
	
	alert : function(context, msg){
		var textMsg = msg == undefined ? '' : msg;
		var typeMsg = 'warning';
		
		switch(context){
			case 'delete' : 
				textMsg = Loc.g('Impossible de supprimer un campagne envoyée ou en cours d‘envoi')+'<br />'+Loc.g("Vous pouvez cependant archiver la campagne.");
				typeMsg = 'error';
				break;
			case 'edit' : 
				textMsg = Loc.g('Impossible de modifier la campagne')+' : <br />'+textMsg;
				typeMsg = 'error';
				break;
			case 'overview' : 
				typeMsg = 'error';
				break;
			case 'unavailable' : 
				typeMsg = 'warning';
				break;
		}
		
		MyWindow.alert(textMsg, {type : typeMsg});
	},
	
    genRecipientsList : function(campaignID){

        $.ajax({
            url			: MyFacture.buildUrl('massmailing_campaign'),
            type		: 'POST',
            data		: {action : 'genRecipientsList', cid : campaignID},
            dataType	: 'json',
            beforeSend	: function(){
                MyFacture.startWait();
                $('#genRecipients i').addClass('fa-spin');
            },
            success		: function(data){
                $('#recipients_btn_enableReload').hide();
                $('#recipients_msg_disableReload').show();
                $('.send_btn_enableActions').hide();
                $('#send_msg_disableActions').show();
                Listing.update('campaignrecipientsListing', true);
                MyFacture.stopWait();
                $('#genRecipients i').removeClass('fa-spin');
            }
        });
    },
	
	sendBAT : function(campaignID, campaignType){
		
		var formID = "campaignBATForm";
		var data = {
			action			: "sendBATForm",
			campaignID		: campaignID,
			campaignType	: campaignType
		};
		
		var options = {
			resizable: false,
			noclose: true,
			title: Loc.g("Test d'envoi de votre campagne"),
			type: "warning",
			width : 600,
			height: 'auto',
			minHeight: 300,
			buttons: [
				{
					text: Loc.g("Annuler"), 
					'class' : 'btn btn-default', 
					click: function () {
						MyWindow.close();
					}
				},
				{
					text: Loc.g("Envoyer"),
					'class' : 'btn btn-primary',
					click: function () {
						$('#'+formID).submit();
					}
				}
			],
			callback : function(){
				
				var defaultCountryCode	= SmartPhoneNumber.getDefaultCountryCode($('#' + formID));
				var preferredCountries	= SmartPhoneNumber.getPreferredCountries(defaultCountryCode);
				var $mobileTpl			= $('#mobileInput-tpl');
				
				$('ul#listBAT').on('focus', 'div.form-input:last', function(){
			
					if($('div.form-group', 'ul#listBAT').length < 5){

						var $input = $('input.e164Number', $(this));

						var $clone			= $($mobileTpl.html());
						var $inputCloned	= $clone.find('input.entry').addClass('e164Number');

						var position = parseInt($input.data('position')) + 1;

						$inputCloned.data('position', position);
						$inputCloned.attr('id', 'testBAT_' + position);

						SmartPhoneNumber.prepareOneField($inputCloned, preferredCountries, defaultCountryCode);
						$clone.appendTo($input.closest('ul'));

					}

				});
				
				$('ul#listBAT').on('blur', 'div.form-input:eq(-2)', function(event){
					
					if(!$(event.srcElement).hasClass('selected-flag')){
						
						var $input = $('input.e164Number', $(this));

						if($input.val() == '' && $('ul#listBAT input.e164Number:last').val() == ''){
							$('ul#listBAT div.form-group:last').remove();
						}

					}

				});
				
				var options = {
					dataType	: 'json',
					data		: {
						action			: 'sendBAT',
						campaignID		: campaignID,
						campaignType	: campaignType
					},
					success		: function(data){
						if(data.status != 'ok'){
						    MyWindow.alert(data.message, {
						        type : 'error'
						    });
						    MyWindow.close();
						    return;
						}
						var formIsOk = MyForm.processJson(data, formID);
						
						if(formIsOk){
							
							// BAT ENVOYE
							MyWindow.close();
							
							if(data.status != 'ok'){

								MyWindow.alert(data.message, {
									type : 'error'
								});
								
							}else{
								
								$('.ovstep').attr('class', 'ovstep campstep_tested');
								
								MyWindow.alert(data.message, {
									type	: 'success',
									buttons : [
										{ text : Loc.g('Fermer'), click : function(){Utils.reload();}}
									]
								});
								
							}
							
						}
						
					}
				};
				
				MyForm.prepare(formID, 'massmailing_sendcampaign', options, true);
			}
		};
		
		MyWindow.load('massmailing_sendcampaign', data, options);
	},
	
	sendScheduled : function(campaignID, campaignType){
		
		var formID = "campaignScheduleForm";
		
		var data = {
			action			: "sendScheduleForm",
			campaignID		: campaignID,
			campaignType	: campaignType
		};
		
		var options = {
			resizable: false,
			noclose: true,
			title: Loc.g("Programmation de l'envoi"),
			type: "warning",
			width : 600,
			height : 300, 
			buttons: [
                {
					text: Loc.g("Annuler"), 
					click: function () {
						MyWindow.close();
					}
				},
                {
					text: Loc.g("Programmer"),
					click	: function () {
						$('#'+formID).submit();
					}
				}
			],
			callback : function(){
				MyFacture.customForm('campaignScheduleForm');

				var date_min	= '';
				var date_format = $('[datepicker]').attr('format');
				switch(date_format) {
					default:
					case 'dmy':
						date_min = Date.today().add(1).days().toString('dd/MM/yyyy');
						break;
					case 'mdy':
						date_min = Date.today().add(1).days().toString('MM/dd/yyyy');
						break;
				}
				$('[datepicker]').datepicker( "option" , 'minDate' , date_min);
				
				var options = {
					dataType : 'json',
					data : {
						action			: 'scheduleSend',
						campaignID		: campaignID,
						campaignType	: campaignType
					},
					success	: function(data){
						if(data.status != 'ok'){
						    MyWindow.alert(data.message, {
						        type : 'error'
						    });
						    MyWindow.close();
						    return;
						}
						var formOK = MyForm.processJson(data, formID);
						
						if(formOK){
							if(data.status != 'ok'){
								var alertOpts = {
									type	: 'warning',
									buttons : [
										{
											text : Loc.g('Fermer'),
											click : function(){
												$(this).dialog('close');
												Utils.reload();
											}
										}
									]
								};
								
							}else{
								var alertOpts = {
									type	: 'confirm',
									buttons : [
										{
											text : Loc.g('Fermer'),
											click : function(){
												Utils.reload();
											}
										}
									]
								};
							}
							
							MyWindow.close();
							MyWindow.alert(data.message, alertOpts);
						}
					}
				};
				
				MyForm.prepare(formID, 'massmailing_sendcampaign', options, true);
			}
		};
		
		MyWindow.load('massmailing_sendcampaign', data, options);
	},
	
	sendInstant : function(campaignID, campaignType){
		
		var options = {
			resizable	: false,
			title		: Loc.g("Envoi de la campagne"),
			type		: "warning",
			buttons		: [
				{
					text	: Loc.g("Non"), 
					'class' : 'btn-default', 
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Oui, envoyer la campagne"),
					'class' : 'btn btn-primary',
					click	: function () {
						
						
						var params = {
							action			: 'instantSend',
							campaignID		: campaignID,
							campaignType	: campaignType,
						};
						
						$.ajax({
							url : '/?_f=massmailing_sendcampaign',
							type : 'POST',
							data : params,
							dataType : 'json',
							beforeSend : function(){
								MyWindow.disable('alertWindow');
								MyWindow.wait('alertWindow');
							},
							success : function(data){
								if(data.status != 'ok'){
									var alertOpts = {
										type	: 'warning',
										buttons : [
											{
												text : Loc.g('Fermer'),
												click : function(){
													$(this).dialog('close');
													Utils.reload();
												}
											}
										]
									};

								}else{
									var alertOpts = {
										type	: 'confirm',
										buttons : [
											{
												text : Loc.g('Fermer'), 
												click : function(){
													Utils.reload();
												}
											}
										]
									};
								}
								MyWindow.awake('alertWindow');
								MyWindow.close('alertWindow');
								MyWindow.alert(data.message, alertOpts);
							}
						});
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Vous êtes sur le point d‘envoyer la campagne.")+'<br /><br />'+Loc.g("Envoyer la campagne ?"), options);
	},
	
	stopIt : function(campaignID, campaignType){
		var options = {
			resizable	: false,
			title		: Loc.g("Envoi de la campagne"),
			type		: "warning",
			width		: 400,
			buttons		: [
				{
					text	: Loc.g("Non"), 
					'class' : 'btn-default', 
					click	: function () {
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Oui, stopper la campagne"),
					'class' : 'btn-primary',
					click	: function () {
						
						
						var params = {
							action			: 'stopit',
							campaignID		: campaignID,
							campaignType	: campaignType,
						};
						
						$.ajax({
							url : '/?_f=massmailing_sendcampaign',
							type : 'POST',
							data : params,
							dataType : 'json',
							beforeSend : function(){
								MyWindow.disable('alertWindow');
								MyWindow.wait('alertWindow');
							},
							success : function(data){
								if(data.status != 'ok'){
									var alertOpts = {
										type	: 'warning',
										buttons : [
											{text : Loc.g('Fermer'), click : function(){$(this).dialog('close');}}
										]
									};

								}else{
									var alertOpts = {
										type	: 'confirm',
										buttons : [
											{text : Loc.g('Fermer'), click : function(){Utils.reload();}}
										]
									};
								}
								MyWindow.awake('alertWindow');
								MyWindow.close('alertWindow');
								MyWindow.alert(data.message, alertOpts);
							}
						});
					}
				}
			]
		};
		
		MyWindow.alert(Loc.g("Vous êtes sur le point d‘arrêter l'envoi de la campagne.")+'<br />'+Loc.g("Stopper la campagne ?"), options);		
	},
	
	initTips : function(campaignID){
		var link = [ 'left','right','top','bottom' ];
		var pos = [ 'leftMiddle','rightMiddle','topMiddle','bottomMiddle' ];
		var curs = [ 'rightMiddle','leftMiddle','bottomMiddle','topMiddle' ];
		
		
		var tipstypes = {'color' : '#468847', 'bg' : '#dff0d8', 'border' : '#d6e9c6'};
		
		$("*[rectip_id]").each(function(){
			var recipientID	= $(this).attr('rectip_id');
			var event		= $(this).attr('rectip_type');
			
			$(this).qtip({
				style : {
					classes : 'custom-qtip rich-qtip',
					def		: false
				},
				position: {
					viewport: true,
					my : 'top center',
					at : 'bottom center'
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout', 
					fixed: true,
					delay: 100
				},
				content:{
					ajax: {
						type: 'GET',
						url		: '/?_f=massmailing_campaign',
						data	: {
							action		: 'qtipRecipient', 
							recipient	: recipientID, 
							event		: event, 
							campaignID	: campaignID
						},
						once	: true
					}
				}
			});
		});
	},

	copy : function(campaignID, campaignType) {		
		var formID = "campaignCopyForm";
		var data = {
			action			: "campaignCopyForm",
			campaignID		: campaignID,
			campaignType	: campaignType
		};
		
		var options = {
			title :  Loc.g('Copie de la campagne'),
			buttons:
					[
                        {
                            text: Loc.g("Annuler"),
                            click: function() {
                                $(this).dialog("close");
                            }
                        },
                        {
							text: Loc.g("Copier"),
							click: function() {
								$("#" + formID).submit();
							}
						}
					],
			width: 400,
			callback: function() {
				var options = {
					data : {action : 'copyRecord'},
					dataType : 'json',
					success : function(data){
						var formOk = MyForm.processJson(data, formID);
						if(formOk) {
						}
					}
				};
				
				MyForm.prepare(formID, 'massmailing_campaign', options, true);
				MyFacture.customForm('#'+formID);
			}
		};
		
		MyWindow.load("massmailing_campaign", data, options);
	},
	loadAutomationTab : function(campaignID){
		if($('#automations_content').html() == ''){
			var options = {
				action	: "loadAutomationTab",
				cid		: campaignID,
			};

			MyFacture.post('massmailing_campaign', options, function (data) {
				$('#automations_content').html(data.listing);
			}, 'json');
		}
	},
	selectSavedSearch : function () {
		var cptOpp = 0;
		var cptThird = 0;
		$("#campaign_segments option:selected").each(function () {
			var listing = $(this)[0].attributes[1].value;
			if(listing == "opportunities"){
				cptOpp++;
			} else {
				cptThird++;
			}
        });

        $("#campaign_segments_favorites option:selected").each(function () {
            var listing = $(this)[0].attributes[1].value;
            if (listing == "opportunities") {
                cptOpp++;
            } else {
                cptThird++;
            }
        });
        
		if(cptOpp > 0 && $('#filedsetOptOpp').is(":hidden")){
			$('#filedsetOptOpp').css('display', "block");
		} else if(cptOpp == 0 && $('#filedsetOptOpp').is(":visible")) {
			$('#filedsetOptOpp').css('display', "none");
		}

		if(cptThird > 0 && $('#filedsetOptThird').is(":hidden")){
			$('#filedsetOptThird').css('display', "block");
		} else if(cptThird == 0 && $('#filedsetOptThird').is(":visible")) {
			$('#filedsetOptThird').css('display', "none");
		}
	},

	unsubscribeRecipientBounce : function (ids) {
		var options = {
			width		: 400,
			resizable   : false,
			noclose     : true,
			title       : this.translations.unsubscribeCampaign,
			buttons     : [
				{
					text 	: this.translations.nothing,
					'class'	: ' btn btn-default',
					click 	: function(){
						$(this).dialog("close");
					}
				},
				{
					text : this.translations.unsubscribe,
					click : function(){
						// action
						var campaignType = $('#campaign_type').val();
						MyFacture.post(
							'massmailing_campaign&action=unsubscribeRecipientBounce', 
							{
								recipients	 : ids,
								campaignType : campaignType
							}, 
							function (data) {
								Push.success(this.translations.unsubscribePlanned);
							}, 
							"json"
						);
						$(this).dialog("close");
					}
				}
			]
		};
		MyWindow.alert(this.translations.confirmUnsubscribe, options);
	}
};

window.Campaigns = {
	prepareFilterForm: function () {
		var options = {success: function (data) {Campaigns.processFilterForm(data);
			}, dataType: "json"};
		MyForm.prepare("campaignsFilterForm", "massmailing_campaigns&action=updateListing", options);
	},
	
	processFilterForm: function (data) {
		Listing.refresh("campaignsListing", data, data.campaigns_metadatas);
	}
};
